/// <amd-module name="Wit/WorkItemForm/Links/GitHub/GitHubDropdownMessages" />
import { FormatComponent } from "VSS/Platform/Components/Format/Format";
import { useService } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { Link } from "VSSUI/Link";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import * as Resources from "Wit/WorkItemForm/Resources";
import { WITCustomerIntelligenceArea, WITCustomerIntelligenceFeature } from "Wit/WorkItemModel/OM";
import * as React from "react";
import { GitHubRateLimit } from "./GitHubDataProviderContracts";

interface IGitHubDropdownMessagesProps {
    nothingFoundInOurSystems: boolean;
    error: string | undefined;
    rateLimitInformation: GitHubRateLimit | undefined;
    resources: {
        loadingFailedMessage: string;
        entities: string;
    };
    setShowSetUrlManually: (value: boolean) => void;
    setError: React.Dispatch<React.SetStateAction<string | undefined>>;
    setHasReachedEndOfArtifactsList: React.Dispatch<React.SetStateAction<boolean>>;
    loadArtifacts: (newFilterText?: string) => Promise<void>;
    unknownError: string;
}

export const GitHubDropdownMessages: React.FC<IGitHubDropdownMessagesProps> = props => {
    const telemetryService = useService<IVssTelemetryService>("IVssTelemetryService");

    React.useEffect(() => {
        if (props.error) {
            telemetryService.publishEvent(WITCustomerIntelligenceArea.WORK_ITEM_TRACKING, WITCustomerIntelligenceFeature.GITHUB_ADD_LINK_ERROR, {
                error: props.error
            });
        }
    }, [props.error]);

    return props.nothingFoundInOurSystems ? (
        <MessageCard severity={MessageCardSeverity.Warning}>
            <FormatComponent format={Resources.GithubNothingFound}>
                <span>{props.resources.entities}</span>
                <Link
                    ariaLabel={Resources.GithubSetUrlManually}
                    onClick={() => {
                        props.setShowSetUrlManually(true);
                    }}
                >
                    {Resources.GithubSetUrlManually}
                </Link>
            </FormatComponent>
        </MessageCard>
    ) : props.error ? (
        <MessageCard severity={MessageCardSeverity.Error}>
            <FormatComponent format={props.resources.loadingFailedMessage}>
                <Link
                    ariaLabel={Resources.GithubRetry}
                    onClick={e => {
                        e.preventDefault();
                        props.setError(undefined);
                        props.setHasReachedEndOfArtifactsList(false);
                        props.loadArtifacts();
                    }}
                >
                    {Resources.GithubRetry}
                </Link>
                <Link
                    ariaLabel={Resources.GithubSetUrlManually}
                    onClick={() => {
                        props.setShowSetUrlManually(true);
                    }}
                >
                    {Resources.GithubSetUrlManually}
                </Link>
            </FormatComponent>
            {props.error !== props.unknownError && (
                <div className="margin-top-8">
                    <FormatComponent format={Resources.GithubErrorDetail}>{props.error}</FormatComponent>
                </div>
            )}
        </MessageCard>
    ) : props.rateLimitInformation && props.rateLimitInformation.remaining / props.rateLimitInformation.limit <= 0.1 ? (
        <MessageCard severity={MessageCardSeverity.Warning}>
            <FormatComponent format={Resources.GithubRateLimitsWarning}>
                <span>{Math.ceil((props.rateLimitInformation.remaining / props.rateLimitInformation.limit) * 100)}</span>
                <span>{props.rateLimitInformation.remaining}</span>
                <span>{props.rateLimitInformation.limit}</span>
            </FormatComponent>
        </MessageCard>
    ) : null;
};
